import { Component, OnInit, Inject, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { okCancelDialogEnum, OkCancelDialogData } from './dlg-ok-cancel.model';

@Component({
  selector: 'xwcomp-lib-dlg-ok-cancel',
  templateUrl: './dlg-ok-cancel.component.html',
  styleUrls: ['./dlg-ok-cancel.component.scss'],
})
export class DlgOkCancelComponent implements OnInit {
  showOk: boolean = true;
  showCancel: boolean = true;
  dialogIcon: string = '';

  constructor(
    public thisDialogRef: MatDialogRef<DlgOkCancelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OkCancelDialogData
  ) {
    if (this.data.dlgType !== undefined) {
      switch (this.data.dlgType) {
        case okCancelDialogEnum.information:
          this.dialogIcon = 'fas fa-info-circle inline-icon ok-cancel-dialog-information';
          this.data.title = this.data.title.length === 0 ? 'Information' : this.data.title;
          break;
        case okCancelDialogEnum.warning:
          this.dialogIcon = 'fas fa-exclamation-triangle inline-icon ok-cancel-dialog-warning';
          this.data.title = this.data.title.length === 0 ? 'Warning' : this.data.title;
          break;
        case okCancelDialogEnum.success:
          this.dialogIcon = 'fas fa-check-circle inline-icon ok-cancel-dialog-success';
          this.data.title = this.data.title.length === 0 ? 'Information' : this.data.title;
          break;
        case okCancelDialogEnum.error:
          this.dialogIcon = 'fas fa-exclamation-circle inline-icon ok-cancel-dialog-error';
          this.data.title = this.data.title.length === 0 ? 'Error' : this.data.title;
          break;
        default:
          this.dialogIcon = '';
          break;
      }
    }
  }

  ngOnInit() {
    if (this.data.oklabel === '') {
      this.showOk = false;
    }
    if (this.data.cancellabel === '') {
      this.showCancel = false;
    }
  }

  onCloseConfirm(): boolean {
    return true;
  }

  onCloseCancel(): boolean {
    return false;
  }
}
